import { render, staticRenderFns } from "./ClassAddressing.vue?vue&type=template&id=e446a09c&"
import script from "./ClassAddressing.vue?vue&type=script&lang=js&"
export * from "./ClassAddressing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports